import PlainPaging from 'app/common/ui-next/plain-paging'

export const WarehouseStockPaging = ({
  total,
  limit,
  currentPage,
  currentPageSize,
  handlePage,
}: {
  total: number
  limit: number
  currentPage: number
  currentPageSize: number
  handlePage: (page: number) => void
}) => {
  return (
    <PlainPaging
      total={total}
      perPage={limit}
      currentPageIndex={currentPage - 1}
      currentPageSize={currentPageSize}
      onPage={handlePage}
    />
  )
}
